import { render, staticRenderFns } from "./AlternateSelectWrapper.vue?vue&type=template&id=bce02fae"
import script from "./AlternateSelectWrapper.vue?vue&type=script&lang=js"
export * from "./AlternateSelectWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports